namespace SPA {
	export namespace Realtor {
		export class DocumentTileView extends Backbone.View {

			public constructor(options: Backbone.ViewOptions = {}) {
				super(options);
			}

			public preinitialize(options: Backbone.ViewOptions = {})
			{
				options.tagName = 'div';
				options.className = 'box object';
			}

		}
	}
}
